import { createMigration } from '../utils';
import SCENES_TO_MIGRATE from './scenes-to-migrate.json';

export const migrationTo9_186 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },

    migrateScene(scene) {
        return scene.withMutations(map => {
            const sceneDesign = map.get('sceneDesign');
            if (SCENES_TO_MIGRATE[sceneDesign] === true) {
                map.set('sceneCategory', 'common');
            }
        });
    },
});
